const finance = [{
  desc: '结算查询接口',
  options: {
    url: '/finance/getSettlementClerkinfo',
    method: 'post'
  },
  vuex: false
}, {
  desc: '查询待审批结算记录数',
  options: {
    url: '/finance/getWaitAuditSettleBatchCount',
    method: 'post'
  }
}, {
  desc: '查询待打款记录数',
  options: {
    url: '/finance/getWaitPayBatchCount',
    method: 'post'
  }
}, {
  desc: '结算单查询导出',
  options: {
    url: '/finance/SettlePayRecordToExcel',
    method: 'post',
    /* headers: {
      'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }, */
    responseType: 'arraybuffer'
  }
}, {
  desc: '结算单查询导出统计数据',
  options: {
    url: '/finance/settlePayStatisticsListToExcel',
    method: 'post',
    responseType: 'arraybuffer'
  }
}, {
  desc: '结算单查询',
  options: {
    url: '/finance/queryInsuranceSettlePayRecord',
    method: 'post'
  }
}, {
  desc: '结算批次查询',
  options: {
    url: '/finance/GetSettleBatch',
    method: 'post'
  }
}, {
  desc: '结算记录查询',
  options: {
    url: '/finance/getSettleBatchList',
    method: 'post'
  }
}, {
  desc: '发票批次查询',
  options: {
    url: '/finance/GetInvoiceManagementList',
    method: 'post'
  }
}, {
  desc: '添加编辑发票批次',
  options: {
    url: '/finance/InvoiceRecordBatchAddOrUpdate',
    method: 'post'
  }
}, {
  desc: '收款批次查询',
  options: {
    url: '/finance/GetReceivablesManagementList',
    method: 'post'
  }
}, {
  desc: '添加编辑收款批次',
  options: {
    url: '/finance/receivablesBatchAddOrUpdate',
    method: 'post'
  }
}, {
  desc: '添加编辑发票批次',
  options: {
    url: '/finance/InvoiceRecordBatchAddOrUpdate',
    method: 'post'
  }
}, {
  desc: '发票或收款入账',
  options: {
    url: '/finance/addInvoiceCapitalEntryInfo',
    method: 'post'
  }
}, {
  desc: '服务机构查询',
  options: {
    url: '/insSupplierOrg/queryInsSupplierOrgList',
    method: 'post'
  }
}, {
  desc: '上游结算结算-结算记录导出',
  options: {
    url: '/finance/settleRecordToExcel',
    method: 'post',
    responseType: 'arraybuffer'
  }
}, {
  desc: '上游结算-结算记录审批',
  options: {
    url: '/finance/insuranceSettleBatchAudit',
    method: 'post'
  }
}, {
  desc: '上游结算-结算记录审批-批量',
  options: {
    url: '/finance/insuranceSettleBatchAuditLot',
    method: 'post'
  }
}, {
  desc: '上游结算-结算记录撤销',
  options: {
    url: '/finance/toRollBackBatch',
    method: 'post'
  }
}, {
  desc: '上游结算-结算记录查看',
  options: {
    url: '/finance/getSettleLog',
    method: 'post'
  }
}, {
  desc: '上游结算-批量选中上游结算',
  options: {
    url: '/finance/PartnerSettleCheck',
    method: 'post'
  }
}, {
  desc: '上游结算-结算记录-导出结算表格',
  options: {
    url: '/finance/getCheckSettleExcel',
    method: 'post'
  }
}, {
  desc: '上游结算-结算记录-导出打款信息',
  options: {
    url: '/finance/getSettlePayMentRecordToExcel',
    method: 'post',
    responseType: 'arraybuffer'
  }
}, {
  desc: '上游结算-结算记录-excel导入提交上游结算',
  options: {
    url: '/finance/ToProcess',
    method: 'post'
  }
}, {
  desc: '上游结算-结算记录-excel导入提交上游结算异常下载',
  options: {
    url: '/finance/checkMsgDownload',
    method: 'get',
    responseType: 'arraybuffer'
  }
}, {
  desc: '上游结算-上游结算批量导入结算异常下载',
  options: {
    url: '/finance/checkMsgDownloadNew',
    method: 'post',
    responseType: 'arraybuffer'
  }
}, {
  desc: '上游结算-结算记录-excel导入提交上游结算根据导入数据结算',
  options: {
    url: '/finance/ToUpdateStatus',
    method: 'post'
  }
}, {
  desc: '上游结算-结算记录-excel导入提交上游结算根据导入数据结算',
  options: {
    url: '/finance/matchPolicy',
    method: 'post'
  }
}, {
  desc: '上游结算-结算记录-异常数据导出',
  options: {
    url: '/finance/PayApplyErrdataToExcel',
    method: 'post',
    responseType: 'arraybuffer'
  }
}, {
  desc: '上游结算-结算记录-删除',
  options: {
    url: '/finance/deleteSettleBatch',
    method: 'post'
  }
}, {
  desc: '众包账户查询',
  options: {
    url: '/finance/queryAccountInfo',
    method: 'get'
  }
}, {
  desc: '批量选中上游对账',
  options: {
    url: '/finance/insuranceSettleApplyCheck',
    method: 'post'
  }
}, {
  desc: 'Excel导入提交上游对账',
  options: {
    url: '/finance/insuranceExcelSettleApplyCheck',
    method: 'post'
  }
}, {
  desc: '上游对账',
  options: {
    url: '/finance/InsuranceSettleCheckToUpdate',
    method: 'post'
  }
}, {
  desc: '批量选中下游结算',
  options: {
    url: '/finance/salesmanSettleApply',
    method: 'post'
  }
}, {
  desc: '下游结算批量修改手续费比对',
  options: {
    url: '/finance/insuranceSettleSyncCommission',
    method: 'post'
  }
}, {
  desc: '下游结算批量修改手续费导出',
  options: {
    url: '/finance/exportSalesmanSyncCommissionFail',
    method: 'post',
    responseType: 'arraybuffer'
  }
}, {
  desc: '导入下游结算',
  options: {
    url: '/finance/salesmanExcelSettleApply',
    method: 'post'
  }
}, {
  desc: '下游结算-选择/导入结算异常 信息导出',
  options: {
    url: '/finance/exportSalesmanExcelSettleFail',
    method: 'post',
    responseType: 'arraybuffer'
  }
}, {
  desc: '下游结算审批',
  options: {
    url: '/finance/insuranceDownSettleAudit',
    method: 'post'
  }
}, {
  desc: '下游结算审批拒绝',
  options: {
    url: '/finance/insuranceDownSettleApplyRollBack',
    method: 'post'
  }
}, {
  desc: '下游结算审批判断线下打款是否超额',
  options: {
    url: '/finance/checkPayeeOverUsed',
    method: 'post'
  }
}, {
  desc: '下游结算待审批列表',
  options: {
    url: '/finance/getDownSettleBatchList',
    method: 'get'
  }
}, {
  desc: '下游结算-导出结算记录 (结算信息)',
  options: {
    url: '/finance/exportSettleItem',
    method: 'post',
    responseType: 'arraybuffer'
  }
}, {
  desc: '下游结算打款撤销',
  options: {
    url: '/finance/insuranceDownSettlePayRollBack',
    method: 'post'
  }
}, {
  desc: '下游结算打款',
  options: {
    url: '/finance/insuranceDownSettlePay',
    method: 'post'
  }
}, {
  desc: '下游结算打款 - 修改打款日期',
  options: {
    url: '/finance/updatePayBatchPayTime',
    method: 'post'
  }
}, {
  desc: '下游结算打款列表',
  options: {
    url: '/finance/queryDownSettlePayList',
    method: 'post'
  }
}, {
  desc: '下游结算打款详情导出',
  options: {
    url: '/finance/insuranceDownSettlePayExport',
    method: 'get',
    responseType: 'arraybuffer'
  }
}, {
  desc: '获取结算打款明细',
  options: {
    url: '/finance/queryDownSettlePayRelation',
    method: 'get'
  }
}, {
  desc: '下游结算打款详情',
  options: {
    url: '/finance/insuranceDownSettlePayDetail',
    method: 'get'
  }
}, {
  desc: '下游结算支付审批单导出',
  options: {
    url: '/finance/dataToPaymentApprovalForm',
    method: 'post',
    responseType: 'arraybuffer'
  }
}, {
  desc: '下游结算审批单导出(支付审批单)',
  options: {
    url: '/finance/approvalExport',
    method: 'post',
    responseType: 'arraybuffer'
  }
}, {
  desc: '下游修改对账状态-[申请对账,撤销对账，对账审批，退回对账，冻结操作]',
  options: {
    url: '/finance/updateInsReconStatus',
    method: 'post'
  }
}, {
  desc: '下游对账异常详情导出',
  options: {
    url: '/finance/updateInsReconExport',
    method: 'post',
    responseType: 'arraybuffer'
  }
}, {
  desc: '保单结算日志查询',
  options: {
    url: '/finance/insSettleLogQuery',
    method: 'post'
  }
}, {
  desc: '导出保单结算日志查询',
  options: {
    url: '/finance/exportInsSettleLog',
    method: 'post',
    responseType: 'arraybuffer'
  }
}, {
  desc: '上游结算导入不存在保单',
  options: {
    url: '/finance/ToImportIns',
    method: 'post'
  }
}, {
  desc: 'Excel导入提交上游结算根据导入数据结算',
  options: {
    url: '/finance/setInsItemSettle',
    method: 'post'
  }
}, {
  desc: '查询业务员收款人',
  options: {
    url: '/finance/getMyPayeeList',
    method: 'get',
    argsParams: true
  }
}, {
  desc: '分配收款人',
  options: {
    url: '/finance/distributeBalanceUser',
    method: 'post'
  }
}, {
  desc: '导出开票管理',
  options: {
    url: '/finance/exportInvoiceManagement',
    method: 'post',
    responseType: 'arraybuffer'
  }
}, {
  desc: '导出收款管理',
  options: {
    url: '/finance/exportReceivablesManagement',
    method: 'post',
    responseType: 'arraybuffer'
  }
}, {
  desc: '查询收款人剩余额度',
  options: {
    url: '/finance/getCustomerLeftCredit',
    method: 'post'
  }
}, {
  desc: '待结金额的接口',
  options: {
    url: '/finance/queryWaitingSettleAmount',
    method: 'post'
  }
}, {
  desc: '打款文件上传',
  options: {
    url: '/finance/uploadSettlePayFile',
    method: 'post'
  }
}, {
  desc: '结算查询-收款人结算记录-导出列表数据',
  options: {
    url: '/finance/settlePayListToExcel',
    method: 'post',
    responseType: 'arraybuffer'
  }
}, {
  desc: '结算查询-待结奖励',
  options: {
    url: '/rewardSettle/getInsRewardSettleStatistics',
    method: 'post'
  }
}, {
  desc: '业务费用额度报表 - 明细报表导出',
  options: {
    url: '/finance/downloadFinanceIntegrationDetail',
    method: 'post',
    responseType: 'arraybuffer'
  }
}, {
  desc: '业务费用额度报表 - 明细报表查询',
  options: {
    url: '/finance/queryFinanceIntegrationDetail',
    method: 'post'
  }
}, {
  desc: '业务费用额度报表 - 汇总报表导出',
  options: {
    url: '/finance/downloadFinanceIntegrationByOrganization',
    method: 'post',
    responseType: 'arraybuffer'
  }
}, {
  desc: '业务费用额度报表 - 汇总报表查询',
  options: {
    url: '/finance/queryFinanceIntegrationByOrganization',
    method: 'post'
  }
}, {
  desc: '查询产销结算列表',
  options: {
    url: '/finance/queryPromotionSettleList',
    method: 'post'
  }
}, {
  desc: '产销保单结算',
  options: {
    url: '/finance/promotionInsuranceSettle',
    method: 'post'
  }
}, {
  desc: '查询产销结算明细',
  options: {
    url: '/finance/queryPromotionSettleDetail',
    method: 'get'
  }
}, {
  desc: '查询商户发票抬头',
  options: {
    url: '/finance/queryInvoiceRises'
  }
}, {
  desc: '查询发票抬头推广账户',
  options: {
    url: '/finance/promotionAccountQuery'
  }
}, {
  desc: '查询登录账户类型（BusinessModel   业务模式 0-众包模式 1-推广模式）',
  options: {
    url: '/finance/zhongbaoPartnerInfo'
  }
}, {
  desc: '查询推广服务商的接口',
  options: {
    url: '/finance/promotionSupplierQuery'
  }
}, {
  desc: '业财转换-上游结算单导出',
  options: {
    url: '/finance/financialConversionRecordToExcel',
    method: 'post',
    responseType: 'arraybuffer'
  }
}]
export default finance



// WEBPACK FOOTER //
// ./src/api/finance.js